import { FunctionComponent, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Filters.module.css";

type FiltersType = {
  onClose?: () => void;
};

const Filters: FunctionComponent<FiltersType> = ({ onClose }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const scrollAnimElements = document.querySelectorAll(
      "[data-animate-on-scroll]"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const targetElement = entry.target;
            targetElement.classList.add(styles.animate);
            observer.unobserve(targetElement);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    for (let i = 0; i < scrollAnimElements.length; i++) {
      observer.observe(scrollAnimElements[i]);
    }

    return () => {
      for (let i = 0; i < scrollAnimElements.length; i++) {
        observer.unobserve(scrollAnimElements[i]);
      }
    };
  }, []);

  const onFrameButtonClick = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  const onFrameButton1Click = useCallback(() => {
    navigate("/dashboard-90");
  }, [navigate]);

  const onFrameButton2Click = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <div className={styles.filters} data-animate-on-scroll>
      <div className={styles.filtersWrapper}>
        <div className={styles.filters1}>Filters</div>
      </div>
      <div className={styles.frameParent}>
        <button className={styles.daysWrapper} onClick={onFrameButtonClick}>
          <div className={styles.days}>30 Days</div>
        </button>
        <button className={styles.daysContainer} onClick={onFrameButton1Click}>
          <div className={styles.months}>90 Days</div>
        </button>
        <button className={styles.daysContainer} onClick={onFrameButton2Click}>
          <div className={styles.months}>6 Months</div>
        </button>
        <button className={styles.daysContainer}>
          <div className={styles.months}>Custom</div>
        </button>
      </div>
    </div>
  );
};

export default Filters;
